// import { ChildrenStoreData } from "@parent-app/types";
import { ChildrenStoreData } from "src/shared/types/src";
import { getAxiosInstance } from "../api";

export const fetchNurserySettings = async ({ child }: { child: ChildrenStoreData }): Promise<any> => {
    const { retryAxios } = getAxiosInstance();
    // retryAxios.defaults.headers.common['Authorization'] = `${child.instanceToken}`;

    return retryAxios.get(`/child/${child.childId}/nursery-settings`).then((res) => {
        const response = res.data;

        if (response && response.status === "success") {
            return response.data;
        }
        return null;
    });
};